import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'
import moment from 'moment'

const urlDetalesReceitaDiaria = '/service/contabilidade/transparencia/receita/'

class DetalesReceitaDiariaService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms ? config.adms.join() : null
        this.state = {
            adms: adms,
        }
    }

    consultar(filtro) {
        let data = {
            dataInicial: filtro.dataInicial ? moment(filtro.dataInicial).format() : null,
            dataFinal: filtro.dataFinal ? moment(filtro.dataFinal).format() : null,
            administracao: filtro.administracao.length > 0 ? filtro.administracao.map(e => e.value).join() : this.state.adms,
            codigoReceita: filtro.codigoReceita ? filtro.codigoReceita : null,
        }
        return this.conex.post(urlDetalesReceitaDiaria + 'detalhesReceitaDiariaPortal/', JSON.stringify(data))
    }
}

export default DetalesReceitaDiariaService
